import React, { Fragment } from "react"
import { setSeoMeta } from './actions';
import { connect } from 'react-redux';
import MainLayout from 'components/components/common/layouts/MainLayout';
import originAxios from 'axios';
import WrapperClasses from './utils/WrapperClasses';
import { ENABLE_TRACKING } from 'components/windowEnvs';

class RouteComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    this.trackChangePages();
    this.updateWrapperClasses();
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    this.updateWrapperClasses();
    if (prevProps.locale !== this.props.locale) {
      this.fetchData();
    }
  }

  trackChangePages = () => {
    var noWindow = (typeof window === 'undefined');
    if (noWindow) return;

    if (window.isInitialLoad) {
      window.isInitialLoad = false;
      return;
    }

    if (ENABLE_TRACKING) {
      console.log("TR ENABLE");
      var url = this.props.location.pathname;
      // *** facebok ***/
      // fbq('track', 'PageView');

      //*** google ***/
      // ga('set', 'page', url);
      // ga('send', 'pageview');
      gtag('config', 'G-E3L18CCYVC', {
        'page_path': url
      });
    }

  }

  updateWrapperClasses = () => {
    const { routeData, isLogged, showSidebarContent } = this.props;
    const { rootClasses, wrapperClasses, divPagesClasses } =
      WrapperClasses.getWrappersClasses(routeData, isLogged, showSidebarContent);
    // const { rootClasses, wrapperClasses, divPagesClasses } =
    //   new WrapperClasses.getWrappersClasses(routeData, isLogged, showSidebarContent);
    window.document.getElementById('root').className = rootClasses;
    window.document.getElementById('wrapDiv').className = wrapperClasses;
    window.document.getElementById('pageDiv').className = divPagesClasses;
  }

  fetchData = () => {
    console.log("RouteComponent locale: ", this.props.locale);
    var noWindow = (typeof window === 'undefined');
    if (noWindow) return;
    var { component, location, locale, fetchPageData, routeData } = this.props;
    if (fetchPageData) {
      var headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-APP-VER': 'fl',
      };

      var requestPath = location.pathname;
      if (routeData && routeData.path === '/' && locale) {
        requestPath = '/' + locale;
      }
      if (!requestPath) {
        requestPath = '/';
      }

      originAxios.get(
        requestPath,
        { params: { locale: locale }, headers: headers },
      )
        .then((result) => {
          var { seo, locale, ...otherData } = result.data;
          this.setState(
            { data: otherData },
            () => {
              if (seo) {
                this.props.setSeoMeta(seo);
              }
            }
          );
        });
    }
  }

  render() {
    var { component: Component, layout: Layout, ...rest } = this.props;
    if (!Layout) {
      Layout = MainLayout;
    }
    return (
      <Layout>
        <Component {...rest} {...this.state.data} />
      </Layout>
    )
  }
}

function mapStateToProps(state) {
  return {
    showSidebarContent: state.booking.showSidebar
  }
}

export default connect(mapStateToProps, { setSeoMeta })(RouteComponent);
